module.exports = __webpack_public_path__ + "static/media/icon-white-personal-finance-app.998273aa.svg";